export enum FormFieldsEnum {
  ActionsToRefineProduct = 'ActionsToRefineProduct',
  ReadinessOfSolution = 'ReadinessOfSolution',
  ApplicationType = 'ApplicationType',
  PreferredLanguage = 'PreferredLanguage',
  Attachment = 'Attachment',
  Challenge = 'Challenge',
  NIP = 'NIP',
  EMAIL = 'Email',
  WEBSITE = 'Website',
  PHONE_NUMBER = 'PhoneNumber',
  COMPANY_REGISTRATION_DATE = 'CompanyRegistrationDate',
  KRS = 'KRS',
}
